export default __webpack_public_path__ + "static/media/group-all-on.169c98b9.svg";